<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Data Table Active User Money Spent
      </b-card-header>
      <b-card-body>
        <money></money>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import Money from './Table'

  export default {
    name: 'moneyUsership',
    components: {
      Money
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
